"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAQPropTypes = exports.CardBodyPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constant2 = require("@airasia/phoenix-components/components/Title/constant");

var FAQPropTypes = {
  PropTypes: {
    theme: _propTypes.default.oneOf(_constant.Themes),
    openFirstItem: _propTypes.default.bool,
    displayIndex: _propTypes.default.bool,
    title: _propTypes.default.string,
    titleType: _propTypes.default.oneOf(Object.values(_constant2.TITLE_TYPES)),
    titleMarginBottom: _propTypes.default.oneOf(_constant.ARR_SPACING_TYPES),
    data: _propTypes.default.arrayOf(_propTypes.default.shape({
      question: _propTypes.default.string,
      answer: _propTypes.default.string
    })),
    size: _propTypes.default.object,
    customProperties: _propTypes.default.object
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    size: {},
    titleType: _constant2.TITLE_TYPES.H3,
    titleMarginBottom: 'normal',
    displayIndex: false
  }
};
exports.FAQPropTypes = FAQPropTypes;
var CardBodyPropTypes = {
  PropTypes: {
    question: _propTypes.default.string,
    answer: _propTypes.default.string,
    displayIndex: _propTypes.default.bool
  }
};
exports.CardBodyPropTypes = CardBodyPropTypes;